
import { buildScriptTag } from "../script-utils";
import { ScriptProps } from "../script-types";

export function getTestScriptForPixel(pixelId: string): string {
  if (!pixelId) {
    throw new Error('Pixel ID is required for test script generation');
  }

  const scriptTag = buildScriptTag({
    pixelId,
    scriptMetadata: null,
    debug: true,
    isTest: true,
  });
  
  return scriptTag;
}
